// extracted by mini-css-extract-plugin
module.exports = {"loading":"Loading_loading__ozJEw","dotFlashing":"Loading_dotFlashing__tgB3F"};